let language = {
    RETURNS_LIST_OPERATION: "操作",
    RETURNS_LIST_RETURN: "退货编号",
    RETURNS_LIST_ORDER: "订单编号",
    RETURNS_LIST_TIME: "申请时间",
    RETURNS_LIST_STATUS: "状态",
    RETURNS_LIST_OPTIONS: "选项",
    RETURNS_LIST_CANCEL: "取消",
    RETURNS_LIST_DETAIL: "详情",
    RETURNS_LIST_EXPRESS: "提交快递信息",
    RETURNS_LIST_EMPTY: "您的退货请求为空。"
}

export { language }
